import { useConfigContext } from "@/app";
// import { useConfigStore } from "@/stores";
import { useCreation } from "ahooks";
import { useCallback } from "react";
import { usePopup } from "../Popup";
import GlobalEvent from '@/utils/globalEvent';
export const CustomerServiceIframe = () => {
  const {
    config
  } = useConfigContext();
  const src = useCreation(() => `/kefu/${config?.kfService}.html?kfServiceBackupUrl=${config?.kfServiceBackupUrl}&kfServiceUrl=${config?.kfServiceUrl}`, []);
  // @ts-ignore;
  const isH5Plus = !!window.plus;
  if (isH5Plus) {
    let kfUrl = `/kefu/${config?.kfService}.html`;
    let params = {
      kfServiceBackupUrl: config?.kfServiceBackupUrl,
      kfServiceUrl: config?.kfServiceUrl
    };
    // @ts-ignore;
    const fnClose = window?.h5p.openCustomerService(kfUrl, params);

    // 监听
    const globalEvent = GlobalEvent.getInstance();
    globalEvent.subscribe('closePopup', (params: any) => {
      console.log('关闭==');
      fnClose();
    });
    return null;
  } else {
    // const { cdn } = useConfigStore();
    // const src = useCreation(() => `${cdn}${config?.kfService}`, []);
    return src ? <iframe id="iframe_customer" title="客服" src={src} style={{
      width: "100%",
      position: "absolute",
      top: 0,
      bottom: 0,
      height: "-webkit-fill-available",
      maxHeight: "100%"
    }} /> : null;
  }
};
export const useCustomerPopup = () => {
  const [popup] = usePopup();
  const show = useCallback(() => {
    return popup({
      closeOnClick: true,
      className: "customer_popup",
      maskClassName: "customer_popup_mask",
      content: <CustomerServiceIframe />
    });
  }, [popup]);
  return [show];
};